import type { AppContext, AppProps } from 'next/app';
import Script from 'next/script';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

/** Integrations */
// import * as fbq from '@libs/integrations/fbpixel';
import MainLayout from '@layouts/main-layout/main-layout';
import ErrorPageComponent from '@components/shared/error-page/error-page';
import { componentsTheme } from '@styles/theme/themeConfig';
import { ThemeProvider } from 'flowbite-react';
import { NextIntlClientProvider } from 'next-intl';
import { ThemeConfig } from 'flowbite-react';
import { set } from 'lodash';
import { fetchTranslations } from '@services/translation.service';

function flattenToNested(messages: Record<string, any>) {
  return Object.entries(messages || {}).reduce((acc, [key, value]) => set(acc, key, value), {});
}

function MyAppProduction({ Component, pageProps }: AppProps) {
  const router = useRouter();

  useEffect(() => {
    // This pageview only triggers the first time (it's important for Pixel to have real information)
    // fbq.pageview();
  }, [router.events]);

  return (
    <>
      {/* <Script
            id={'facebook-pixel'}
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', ${fbq.FB_PIXEL_ID});
          `
            }}
        /> */}
      <Script
        id={'cookie-policy'}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          var _iub = _iub || [];
          _iub.csConfiguration = {"siteId":4038619,"cookiePolicyId":94179763,"lang":"en","storage":{"useSiteId":true}};
        `,
        }}
      />
      <Script
        src="https://cs.iubenda.com/autoblocking/4038619.js"
        strategy="afterInteractive"
      />
      <Script
        src="//cdn.iubenda.com/cs/gpp/stub.js"
        strategy="afterInteractive"
      />
      <Script
        src="//cdn.iubenda.com/cs/iubenda_cs.js"
        async
        strategy="afterInteractive"
      />
      <Script
        src="https://cdn.iubenda.com/iubenda.js"
        async
        strategy="afterInteractive"
      />

      {/* Exchanger Widget Scripts - Load globally to prevent crashes */}
      <Script src="/exchanger-widget/polyfills.js" type="module" strategy="beforeInteractive" />
      <Script src="/exchanger-widget/main.js" type="module" strategy="beforeInteractive" />

      {!pageProps.error ? (
        <NextIntlClientProvider
          messages={flattenToNested(pageProps.messages)}
          locale={pageProps.locale || 'en'}
        >
          <ThemeConfig dark={false} />
          <ThemeProvider theme={componentsTheme}>
            <Component {...pageProps} />
          </ThemeProvider>
        </NextIntlClientProvider>
      ) : (
        <MainLayout>
          <ErrorPageComponent
            errorStatus={pageProps.error.errorStatus}
            prefix={pageProps.error.message}
          />
        </MainLayout>
      )}
    </>
  );
}

MyAppProduction.getInitialProps = async ({ Component, ctx }: AppContext) => {
  const pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {};
  const locale = ctx.locale || 'en';
  let messages = {};
  try {
    messages = await fetchTranslations(locale);
  } catch (e) {
    // fallback: empty messages
  }
  return { pageProps: { ...pageProps, messages, locale } };
};

export default MyAppProduction;
